import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { Input } from '@/components/ui/input';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';
    import { useProcedureResponsiblesData } from '@/composables/useProcedureResponsiblesData';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedureForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasPermission } = usePermissions();

    const { procedureResponsibles, isProcedureResponsiblesPending } =
        useProcedureResponsiblesData();

    const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "procedure_task",
      label: "dashboards.procedures"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Textarea), {
          id: "procedure_task",
          modelValue: _ctx.form.procedure_task,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.procedure_task) = $event)),
          placeholder: _unref(t)('dashboards.procedures'),
          disabled: !_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_UPDATE)
        }, null, 8, ["modelValue", "placeholder", "disabled"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "procedure_responsible",
      label: "dashboards.procedures_choose_responsible"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.procedure_responsible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.procedure_responsible) = $event)),
          options: _unref(procedureResponsibles),
          "show-remove-button": false,
          loading: _unref(isProcedureResponsiblesPending),
          disabled: !_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_UPDATE),
          "label-by": "name",
          "value-by": "id"
        }, null, 8, ["modelValue", "options", "loading", "disabled"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "procedure_deadline",
      label: "dashboards.tasks_deadline"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          modelValue: _ctx.form.procedure_deadline,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.procedure_deadline) = $event)),
          disabled: !_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_UPDATE),
          type: "number",
          placeholder: _unref(t)('dashboards.tasks_deadline')
        }, null, 8, ["modelValue", "disabled", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})